import React from 'react';

// State refund data
const stateRefunds = [
  { state: "Alabama", link: "http://www.ador.state.al.us/incometax/vrespinstructions.html", isTaxFree: false },
  { state: "Alaska", link: "", isTaxFree: true },
  { state: "Arizona", link: "https://www.aztaxes.gov/default.aspx", isTaxFree: false },
  { state: "Arkansas", link: "https://www.ark.org/dfa_ri/app/login.html", isTaxFree: false },
  { state: "California", link: "https://www.ftb.ca.gov/online/refund/index.asp", isTaxFree: false },
  { state: "Colorado", link: "https://www.colorado.gov/tax", isTaxFree: false },
  { state: "Connecticut", link: "http://www.ct.gov/drs/cwp/view.asp?a=1462&q=266274", isTaxFree: false },
  { state: "Delaware", link: "https://dorweb.revenue.delaware.gov/refinq/", isTaxFree: false },
  { state: "Florida", link: "", isTaxFree: true },
  { state: "Georgia", link: "https://gtc.dor.ga.gov/_/", isTaxFree: false },
  { state: "Hawaii", link: "https://tax.ehawaii.gov/hoihoi/refund.html", isTaxFree: false },
  { state: "Idaho", link: "https://www.accessidaho.org/secure/istc/refund/status.html", isTaxFree: false },
  { state: "Illinois", link: "https://www.revenue.state.il.us/app/refund/servlet/RefundStatus", isTaxFree: false },
  { state: "Indiana", link: "https://secure.in.gov/apps/dor/tax/refund/", isTaxFree: false },
  { state: "Iowa", link: "https://www.idr.iowa.gov/wheresmyrefund/login.aspx", isTaxFree: false },
  { state: "Kansas", link: "https://www.kdor.org/refundstatus/default.asp", isTaxFree: false },
  { state: "Kentucky", link: "http://revenue.ky.gov/refund.htm", isTaxFree: false },
  { state: "Louisiana", link: "https://esweb.revenue.louisiana.gov/IndividualIncomeTax/Login.aspx", isTaxFree: false },
  { state: "Maine", link: "https://portal.maine.gov/refundstatus/Registration.do", isTaxFree: false },
  { state: "Maryland", link: "https://interactive.marylandtaxes.com/INDIV/refundstatus/home.aspx", isTaxFree: false },
  { state: "Massachusetts", link: "https://wfb.dor.state.ma.us/webfile/wsi/public/webforms/login.aspx", isTaxFree: false },
  { state: "Michigan", link: "https://treas-secure.treas.state.mi.us/eservice_enu/start.swe", isTaxFree: false },
  { state: "Minnesota", link: "https://www.mndor.state.mn.us/tp/refund/", isTaxFree: false },
  { state: "Mississippi", link: "http://www.dor.ms.gov/inquiry.html?dept=IIT", isTaxFree: false },
  { state: "Missouri", link: "https://dors.mo.gov/tax/taxinq/welcome.jsp", isTaxFree: false },
  { state: "Montana", link: "https://tap.dor.mt.gov/", isTaxFree: false },
  { state: "Nebraska", link: "https://ndr-refundstatus.ne.gov/refundstatus/public/search.faces", isTaxFree: false },
  { state: "Nevada", link: "http://tax.state.nv.us/", isTaxFree: false },
  { state: "New Hampshire", link: "", isTaxFree: true },
  { state: "New Jersey", link: "https://www16.state.nj.us/TYTR_TGI_INQ/servlet/COMMON/prompt", isTaxFree: false },
  { state: "New Mexico", link: "https://tap.state.nm.us/tap/_/#1", isTaxFree: false },
  { state: "New York", link: "https://www8.tax.ny.gov/PRIS/prisStart", isTaxFree: false },
  { state: "North Carolina", link: "https://eservices.dor.nc.gov/wheresmyrefund/SelectionServlet", isTaxFree: false },
  { state: "North Dakota", link: "https://secure.apps.state.nd.us/tax/refundstatus/refundstatus.htm", isTaxFree: false },
  { state: "Ohio", link: "https://www.tax.state.oh.us/IFILE/WheresMyRefundWeb/wheresmyrefund.jsp", isTaxFree: false },
  { state: "Oklahoma", link: "http://www.tax.ok.gov/refund.html", isTaxFree: false },
  { state: "Oregon", link: "https://secure.dor.state.or.us/refund/refund.cfm", isTaxFree: false },
  { state: "Pennsylvania", link: "https://www.doreservices.state.pa.us/pitservices/wheresmyrefund.aspx", isTaxFree: false },
  { state: "Rhode Island", link: "https://www.ri.gov/taxation/refund/", isTaxFree: false },
  { state: "South Carolina", link: "https://www.sctax.org/refundstatus/refund.aspx", isTaxFree: false },
  { state: "South Dakota", link: "", isTaxFree: true },
  { state: "Tennessee", link: "", isTaxFree: true },
  { state: "Texas", link: "", isTaxFree: true },
  { state: "Utah", link: "https://tap.tax.utah.gov/TaxExpress/", isTaxFree: false },
  { state: "Vermont", link: "http://www.state.vt.us/tax/eservices.shtml", isTaxFree: false },
  { state: "Virginia", link: "https://www.individual.tax.virginia.gov/VTOL/IndRefundStatus.seam", isTaxFree: false },
  { state: "Washington", link: "", isTaxFree: true },
  { state: "West Virginia", link: "https://www.state.wv.us/secure/tax/", isTaxFree: false },
  { state: "Wisconsin", link: "https://www.revenue.wi.gov/individuals/index.html", isTaxFree: false },
  { state: "Wyoming", link: "http://revenue.wyo.gov/", isTaxFree: false },
];

export default function RefundStatus() {
  return (
    <div className="container my-5">
      {/* Federal Refund Section */}
      <section className="mb-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold mb-2" style={{ 
            color: "#6B46C1", 
            fontFamily: "'Poppins', sans-serif",
            fontSize: "2.5rem"
          }}>
            Federal Tax Refund Status
          </h2>
          <p className="text-secondary fs-5">Check your federal tax refund status through the official IRS portal</p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card h-100 shadow-lg border-0 rounded-4" style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 10px 30px rgba(102, 126, 234, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
            }}>
              <div className="card-body text-white p-4">
                <div className="d-flex align-items-center mb-3">
                  <i className="bi bi-receipt-cutoff fs-1 me-3"></i>
                  <h4 className="card-title mb-0 fw-bold">Federal Refund Status</h4>
                </div>
                <p className="card-text mb-4" style={{ opacity: 0.9 }}>
                  Check your federal tax refund status through the official IRS portal.
                </p>
                <a href="https://sa.www4.irs.gov/irfof/lang/en/irfofgetstatus.jsp" 
                   target="_blank" 
                   rel="noopener noreferrer" 
                   className="btn btn-light btn-lg w-100 fw-bold rounded-pill"
                   style={{
                     background: "#fff",
                     color: "#6B46C1",
                     border: "none"
                   }}>
                  <i className="bi bi-search me-2"></i>Check Status
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* State Refund Status Section */}
      <section className="mt-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold mb-2" style={{ 
            color: "#6B46C1", 
            fontFamily: "'Poppins', sans-serif",
            fontSize: "2.5rem"
          }}>
            State Refund Status
          </h2>
          <p className="text-secondary fs-5">Find your state tax refund status by selecting your state below</p>
        </div>
        <div className="table-responsive shadow-sm rounded-4 overflow-hidden">
          <table className="table table-hover mb-0" style={{ backgroundColor: "#fff" }}>
            <thead style={{
              background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
              color: "#fff"
            }}>
              <tr>
                <th style={{ 
                  padding: "1rem",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: "600"
                }}>State</th>
                <th style={{ 
                  padding: "1rem",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: "600"
                }}>Refund Status Link</th>
              </tr>
            </thead>
            <tbody>
              {stateRefunds.map((item, index) => (
                <tr key={index} 
                    style={{ transition: "background-color 0.2s" }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}>
                  <td style={{ padding: "1rem", fontWeight: "500" }}>{item.state}</td>
                  <td style={{ padding: "1rem" }}>
                    {item.isTaxFree ? (
                      <span style={{ color: "#6c757d" }}>Tax Free State</span>
                    ) : (
                      <a href={item.link} 
                         target="_blank" 
                         rel="noopener noreferrer"
                         className="text-decoration-none fw-semibold"
                         style={{ color: "#6B46C1" }}>
                        <i className="bi bi-box-arrow-up-right me-2"></i>Check Status
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Contact Information */}
      <section className="mt-5 py-5" style={{
        background: "linear-gradient(135deg, #f7f8ff 0%, #f8e0f5 100%)",
        borderRadius: "2rem"
      }}>
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            <h3 className="fw-bold mb-3" style={{ 
              color: "#6B46C1", 
              fontFamily: "'Poppins', sans-serif"
            }}>
              Need Assistance?
            </h3>
            <p className="fs-5 text-secondary mb-4">
              Our tax experts are here to help you with your refund status inquiries
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <a href="tel:+919966969809" 
                 className="btn btn-primary btn-lg rounded-pill px-4"
                 style={{
                   background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                   border: "none",
                   fontWeight: "600"
                 }}>
                <i className="bi bi-telephone me-2"></i>+91 996-696-9809
              </a>
              <a href="tel:+19436789878" 
                 className="btn btn-primary btn-lg rounded-pill px-4"
                 style={{
                   background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                   border: "none",
                   fontWeight: "600"
                 }}>
                <i className="bi bi-telephone me-2"></i>+1 (943) 678 9878
              </a>
              <a href="mailto:info@nexenconsults.com" 
                 className="btn btn-outline-primary btn-lg rounded-pill px-4"
                 style={{
                   borderColor: "#6B46C1",
                   color: "#6B46C1",
                   fontWeight: "600"
                 }}>
                <i className="bi bi-envelope me-2"></i>Email Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
